import { jsx as _jsx } from "react/jsx-runtime";
import { CustomOuterLink } from './styles';
const OuterLink = ({ children, to, className, color, }) => (_jsx(CustomOuterLink, { className: className, href: to, color: color, target: "_blank", rel: "noopener noreferrer", children: children }));
export default OuterLink;
//# sourceMappingURL=OuterLink.js.map